module.exports = __webpack_public_path__ + "static/media/icon-enable2fa.c5a30078.svg";